export const PREFS_KEY = "marsilya-prefs";

export const PREF_DEFAULTS = {
  ghost: false,
  hideWins: false,
  hideRace: false,
  hideBalance: false,
  streamer: false,
  privateProfile: false,
  hideActivity: false,
  stealthIp: false,
  hideBonus: false,
  muteSfx: false,
  blockTips: false,
  rainIgnore: false,
  marketing: true,
  notifySite: true,
  loginAlerts: true,
};

export function mergePrefs(raw) {
  const source = raw && typeof raw === "object" ? raw : {};
  const next = { ...PREF_DEFAULTS };
  Object.keys(PREF_DEFAULTS).forEach((key) => {
    if (source[key] !== undefined) next[key] = Boolean(source[key]);
  });
  return next;
}

export function readPrefs() {
  try {
    return mergePrefs(JSON.parse(localStorage.getItem(PREFS_KEY) || "{}"));
  } catch {
    return { ...PREF_DEFAULTS };
  }
}

export function writePrefs(raw) {
  const next = mergePrefs(raw);
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  applyPrefs(next);
  return next;
}

export function applyPrefs(raw) {
  if (typeof document === "undefined") return mergePrefs(raw);
  const prefs = mergePrefs(raw);
  document.body.classList.toggle("is-ghost", Boolean(prefs.ghost));
  document.body.classList.toggle("is-streamer", Boolean(prefs.streamer));
  document.body.classList.toggle("is-hide-balance", Boolean(prefs.hideBalance));
  document.body.classList.toggle("is-hide-wins", Boolean(prefs.hideWins));
  document.body.classList.toggle("is-private-profile", Boolean(prefs.privateProfile));
  return prefs;
}

export function maskEmail(value) {
  const text = String(value || "");
  const at = text.indexOf("@");
  if (at < 1) return text ? "••••" : "—";
  return `${text.slice(0, 1)}***${text.slice(at)}`;
}

export function maskPhone(value) {
  const digits = String(value || "").replace(/\D/g, "");
  if (digits.length < 4) return digits ? "••••" : "—";
  return `${digits.slice(0, 2)}•••${digits.slice(-2)}`;
}
